import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import ReactDOM from 'react-dom';

//import components
import SingleFilterContent from './SingleFilterContent.js';

class SingleFilter extends Component {
    constructor() {
        super();
        this.state = {
        };
    };

    componentDidMount() {
        this.setNode();
        this.updateWidth();

        window.addEventListener('mousedown', this.updateClick);
    };

    componentDidUpdate(prevProps, prevState) {
        const {openedFilter, id} = this.props;
        const active = openedFilter === id;

        if (!active) {
            window.removeEventListener("resize", this.updateWidth);
        }
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
        window.removeEventListener('mousedown', this.updateClick);
    };

    getSelectedOptions = (arr) => {
        const newArr = [];

        const getSelectedOptionsRec = (arr) => {
            arr.forEach(function(item, index) {
                if (item.selected) {
                    newArr.push(item);
                }

                if (item.children) {
                    getSelectedOptionsRec(item.children);
                }
            });
        };

        getSelectedOptionsRec(arr);

        return newArr;
    };

    isTouched = () => {
        const currentFilter = this.props.selectedFilters ? this.props.selectedFilters.filter(filter => filter.id === this.props.id)[0] : null;
        const selectedOptions = this.props.options ? this.getSelectedOptions(this.props.options) : [];

        if (currentFilter) {
            let isTouched = false;

            selectedOptions.forEach(function(item, index) {
                if (currentFilter.value.filter(filter => filter.id === item.id).length < 1) {
                    isTouched = true;
                }
            });

            currentFilter.value.forEach(function(item, index) {
                if (selectedOptions.filter(filter => filter.id === item.id).length < 1) {
                    isTouched = true;
                }
            });

            return isTouched;
        } else {
            return selectedOptions.length > 0;
        }
    };

    setNode = () => {
        this.domNodeFilterTrigger = ReactDOM.findDOMNode(this.filterTrigger);
        window.addEventListener('resize', this.updateWidth);
    };

    setWrapperRef = (node) => {
       this.filter = node;
    }

    updateClick = (e) => {
        const {openedFilter, id, setOpenedFilter} = this.props;
        const active = openedFilter === id;

        if (this.filter && !this.filter.contains(e.target) && active){
           setOpenedFilter(null);
        }
    };

    updateWidth = () => {
        this.filterTriggerOffset = this.domNodeFilterTrigger.getBoundingClientRect();
        this.setState({filterTriggerOffsetWidth: this.filterTriggerOffset.width});
    };

    render() {
        const {clang, componentData, id, isDisabled, hideDefaultApply, applyFilter, common, isSelected, setOpenedFilter, openedFilter} = this.props;
        const {filterTriggerOffsetWidth} = this.state;

        const active = openedFilter === id;

        return (
            <div className={`filter ${common ? 'global' : ''}`} ref={this.setWrapperRef}>
                <button
                    className="filter__trigger"
                    onClick={() => setOpenedFilter(active ? null : id)}
                    ref={el => this.filterTrigger = el}
                    disabled={isDisabled}>
                    <span className="filter__trigger__label">{lang[clang].filter_labels[id]}</span>
                    {isSelected && <span className="filter__selected"></span>}
                    {!isSelected && !active && <span className="filter__trigger__chevron"></span>}
                    {!isSelected && active && <span className="filter__trigger__chevron--up"></span>}
                </button>
                {active && <SingleFilterContent
                              isTouched={this.isTouched()}
                              componentData={componentData}
                              hideDefaultApply={hideDefaultApply}
                              applyFilter={applyFilter}
                              triggerWidth={filterTriggerOffsetWidth}
                              setOpenedFilter={setOpenedFilter}
                              id={id}/>}
            </div>
        );
    };
};

SingleFilter.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(SingleFilter);



// WEBPACK FOOTER //
// ./src/components/simple-search-results/SingleFilter.js